// extracted by mini-css-extract-plugin
module.exports = {"title":"_2BiJr","separator":"U4Obi","paragraph":"d-j5X","button":"_1IqpS","rightButton":"_3VyHc _1IqpS"};